import React from 'react';
import { Typography } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { ImageInput } from 'react-admin';
import RASimpleForm from './RASimpleForm';
import { asyncFetch, compressImages } from '../../helperFunctions';

export default () => {
  const isAdmin = useSelector(state => state.auth.isAdmin);
  const dispatch = useDispatch();

  const upload = async image => {
    const compressPromise = compressImages([image]);
    const compressedImages = await compressPromise;
    const formData = new FormData();
    formData.append('image', compressedImages[0]);
    (async () => {
      await asyncFetch(
        `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/test-upload-image`,
        {
          method: 'POST',
          mode: 'cors',
          referrerPolicy: 'strict-origin-when-cross-origin',
          body: formData,
        },
        undefined,
        undefined,
        dispatch
      );
    })();
  };

  return (
    (isAdmin || process.env.REACT_APP_ENV !== 'Prod') && (
      <>
        <RASimpleForm variant="standard" toolbar={null} cardPadding="0px" margin="none">
          <ImageInput
            source="image"
            label=""
            accept="image/*"
            onChange={x => upload(x)}
            placeholder={
              <div style={{ backgroundColor: '#da291c', padding: '3px' }}>
                <Typography>Upload</Typography>
              </div>
            }
            fullWidth
          >
            <></>
          </ImageInput>
        </RASimpleForm>
      </>
    )
  );
};
